const hasRawValues = (items: any[]): items is string[] => {
    return items.some(item => typeof item === 'string');
};

export { hasRawValues };
